import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
    dropDownContainer: {
        position: "relative",
        zIndex: 10,
    },
});

export function Dropdown({ children, ...props }: React.ComponentProps<"div">): React.JSX.Element {
    const { classes } = useStyles();

    return (
        <div className={classes.dropDownContainer} {...props}>
            {children}
        </div>
    );
}
